import {
  GET_SUBMISSIONS,
  GET_SUBMISSION,
  ADD_SUBMISSION,
  UPDATE_SUBMISSION,
  DELETE_SUBMISSION,
  REVIEW_SUBMISSION,
  SUBMISSIONS_LOADING,
  GET_SUBMISSION_STATS,
  GET_USER_SUBMISSION_STATUS,
  SET_SUBMISSIONS_PAGE,
  CLEAR_CURRENT_SUBMISSION
} from '../actions/types';

const initialState = {
  submissions: [],
  currentSubmission: null,
  loading: false,
  error: null,
  stats: {
    total: 0,
    pending: 0,
    approved: 0,
    rejected: 0
  },
  currentPage: 1,
  totalPages: 0,
  totalSubmissions: 0,
  hasNextPage: false,
  hasPrevPage: false,
  userSubmissionStatus: {}
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_SUBMISSIONS:
      return {
        ...state,
        submissions: action.payload.submissions || action.payload,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 0,
        totalSubmissions: action.payload.totalSubmissions || 0,
        hasNextPage: action.payload.hasNextPage || false,
        hasPrevPage: action.payload.hasPrevPage || false,
        loading: false
      };
    
    case GET_SUBMISSION:
      return {
        ...state,
        currentSubmission: action.payload,
        loading: false
      };
    
    case ADD_SUBMISSION:
      const newSubmission = action.payload;
      const newUserSubmissionStatus = { ...state.userSubmissionStatus };

      // Update userSubmissionStatus with the new submission
      if (newSubmission.submissionForm) {
        const formId = typeof newSubmission.submissionForm === 'object'
          ? newSubmission.submissionForm._id
          : newSubmission.submissionForm;

        newUserSubmissionStatus[formId] = {
          formId,
          hasSubmission: true,
          submission: {
            _id: newSubmission._id,
            status: newSubmission.status,
            link: newSubmission.link,
            comment: newSubmission.comment,
            achievementImages: newSubmission.achievementImages || (newSubmission.achievementImage ? [newSubmission.achievementImage] : []),
            adminComment: newSubmission.adminComment,
            submittedAt: newSubmission.submittedAt,
            reviewedAt: newSubmission.reviewedAt,
            reviewedBy: newSubmission.reviewedBy,
            isAutomatic: newSubmission.isAutomatic
          }
        };
      }

      return {
        ...state,
        submissions: [newSubmission, ...state.submissions],
        userSubmissionStatus: newUserSubmissionStatus,
        loading: false
      };
    
    case UPDATE_SUBMISSION:
      const updatedSubmission = action.payload;
      const updatedUserSubmissionStatus = { ...state.userSubmissionStatus };
      
      // Update userSubmissionStatus if this submission exists there
      Object.keys(updatedUserSubmissionStatus).forEach(formId => {
        const statusData = updatedUserSubmissionStatus[formId];
        if (statusData.hasSubmission && statusData.submission._id === updatedSubmission._id) {
          updatedUserSubmissionStatus[formId] = {
            ...statusData,
            submission: {
              ...statusData.submission,
              _id: updatedSubmission._id,
              status: updatedSubmission.status,
              link: updatedSubmission.link,
              comment: updatedSubmission.comment,
              achievementImages: updatedSubmission.achievementImages || (updatedSubmission.achievementImage ? [updatedSubmission.achievementImage] : []),
              adminComment: updatedSubmission.adminComment,
              submittedAt: updatedSubmission.submittedAt,
              reviewedAt: updatedSubmission.reviewedAt,
              reviewedBy: updatedSubmission.reviewedBy,
              isAutomatic: updatedSubmission.isAutomatic
            }
          };
        }
      });
      
      return {
        ...state,
        submissions: state.submissions.map(submission =>
          submission._id === updatedSubmission._id ? updatedSubmission : submission
        ),
        currentSubmission: state.currentSubmission && 
          state.currentSubmission._id === updatedSubmission._id ? updatedSubmission : state.currentSubmission,
        userSubmissionStatus: updatedUserSubmissionStatus,
        loading: false
      };
    
    case DELETE_SUBMISSION:
      return {
        ...state,
        submissions: state.submissions.filter(submission => submission._id !== action.payload),
        currentSubmission: state.currentSubmission && 
          state.currentSubmission._id === action.payload ? null : state.currentSubmission,
        loading: false
      };
    
    case REVIEW_SUBMISSION:
      return {
        ...state,
        submissions: state.submissions.map(submission =>
          submission._id === action.payload._id ? action.payload : submission
        ),
        currentSubmission: state.currentSubmission && 
          state.currentSubmission._id === action.payload._id ? action.payload : state.currentSubmission,
        loading: false
      };
    
    case GET_SUBMISSION_STATS:
      return {
        ...state,
        stats: action.payload,
        loading: false
      };
    
    case GET_USER_SUBMISSION_STATUS:
      return {
        ...state,
        userSubmissionStatus: {
          ...state.userSubmissionStatus,
          [action.payload.formId]: action.payload
        }
      };
    
    case SUBMISSIONS_LOADING:
      return {
        ...state,
        loading: true
      };

    case SET_SUBMISSIONS_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };

    case CLEAR_CURRENT_SUBMISSION:
      return {
        ...state,
        currentSubmission: null
      };

    default:
      return state;
  }
} 